import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import useWindowSize from "../../common/windowSize";
import DesktopMenu from '../../common/DesktopMenu/index';
import MobileMenu from '../../common/MobileMenu/index';
import NewFooter from "../../common/NewFooter";
import { Background } from "../../common/Faq/styles";
import { 
  HelloMessage, 
} from "../AdminPanel/styles";
import { LoginButton } from "../Login/styles";

const ErrorScreen = () => {
  const size = useWindowSize();
  const [ mobileMenu, setMobileMenu ] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? (
        <MobileMenu single={true} />
      ) : (
        <DesktopMenu single={true} />
      )}
      <Background marginTop adminPanel>
          <HelloMessage>404 Go back</HelloMessage>
          <LoginButton 
            type="submit"
            onClick={() => navigate(-1)}
            style={{ width: '100px', alignSelf: "flex-end", margin: "25px 90px 0 0"}}
            >
            Back
          </LoginButton>
      </Background>
      <NewFooter />
    </React.Fragment>
  );
}

export default ErrorScreen;
